import RegistrationLayout from "@Components/RagistrationLayout";
import { useFormik } from "formik";
import * as yup from "yup";
import { FormHelperText, Grid } from "@mui/material";
import { useState } from "react";
import { useRouter } from "next/router";
import { StyledGreenButton, StyledCustomInput } from "@Styled/Common";
import Password from "./password";
import VerifyOtp from "./verifyOtp";
import React from "react";
import { apiUser } from "@Services/API/IndividualApi's/User";
import Spinner from "../Common/Spinner";
import { theme } from "@Definitions/Styled";
import Interceptor from "hoc/Interceptor";

interface IFormikValues {
  mobileNumber: string;
  password: string;
}

const validationSchema = yup.object({
  mobileNumber: yup
    .number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .test(
      "len",
      "Mobile Number should be of 10 numbers length",
      (val: any) => val?.toString().length === 10
    )
    .required("A phone number is required"),
});

const Login = () => {
  const [phoneNo, setPhoneNo] = useState<string>("");
  const [index, setIndex] = useState<number>(0);
  const [loader, setLoader] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const router = useRouter();

  async function checkUserExistance(values: IFormikValues) {
    const phoneReg = new RegExp(/^[6-9]{1}/);
    if (phoneReg.test(values.mobileNumber)) {
      const userPhone = {
        phoneNumber: values.mobileNumber,
      };
      setLoader(true);
      try {
        const response = await apiUser.checkUserExists(userPhone);
        setLoader(false);
        setPhoneNo(values.mobileNumber);
        setIndex(1);
      } catch (err) {
        setLoader(false);
      }
    } else {
      setError(true);
    }
  }

  const formik = useFormik({
    initialValues: {
      mobileNumber: "",
    },
    validationSchema: validationSchema,

    onSubmit: (values: IFormikValues) => {
      checkUserExistance(values);
      // setLoader(true);
    },
  });

  const handleIndexChange = () => {
    setIndex(2);
  };

  React.useEffect(() => storePathValues, [router]);

  function storePathValues() {
    const storage = globalThis?.sessionStorage;
    if (!storage) return;
    // Set the previous path as the value of the current path.
    const prevPath = storage.getItem("currentPath");
    storage.setItem("prevPath", prevPath!);
    // Set the current path value by looking at the browser's location object.
    storage.setItem("currentPath", globalThis.location.pathname);
  }

  return (
    <>
      {index === 0 ? (
        <RegistrationLayout
          title="Login To Your Account"
          dividerText="New to Econut"
          buttonText="Create your Econut account"
          onButtonClicked={() => {
            router.push("/register");
          }}
          loginModal={true}
        >
          <Grid item>
            <form onSubmit={formik.handleSubmit}>
              <Grid sx={{ marginBottom: "1rem" }}>
                <StyledCustomInput
                  fullWidth
                  id="mobileNumber"
                  name="mobileNumber"
                  label="Mobile Number"
                  type="tel"
                  value={
                    formik.values.mobileNumber
                      ? parseInt(formik.values.mobileNumber)
                      : formik.values.mobileNumber
                  }
                  onChange={(e) => {
                    setError(false);
                    e.target.value = e.target.value.slice(0, 10);
                    if (e.target.value && !Number(e.target.value)) return;
                    formik.handleChange(e);
                  }}
                  onBlur={formik.handleBlur}
                  placeholder=""
                  error={
                    formik.touched.mobileNumber &&
                    Boolean(formik.errors.mobileNumber)
                  }
                  helperText={
                    formik.touched.mobileNumber && formik.errors.mobileNumber
                  }
                />
                {error ? (
                  <FormHelperText error={error} style={{ marginLeft: "14px" }}>
                    Mobile number should start from 6-9
                  </FormHelperText>
                ) : (
                  ""
                )}
              </Grid>

              <StyledGreenButton type="submit" fullWidth>
                {loader ? (
                  <Spinner spinColor={theme.palette.neutral.main} />
                ) : (
                  ""
                )}{" "}
                Continue
              </StyledGreenButton>
            </form>
          </Grid>
        </RegistrationLayout>
      ) : index === 1 ? (
        <Password phoneNumber={phoneNo} handleIndexChange={handleIndexChange} />
      ) : index === 2 ? (
        <VerifyOtp phoneNumber={phoneNo} />
      ) : (
        ""
      )}
    </>
  );
};
export default Interceptor(Login);
